import React from 'react';
import { styled } from '@compiled/react';
import { Label } from '@atlaskit/form';
import { token } from '@atlaskit/tokens';
import Placeholder from '@atlassian/jira-placeholder';
import { lazy } from '@atlassian/react-loosely-lazy';
import { DatePickerReadView } from '../../../common/ui/version-dates';
import {
	InlineEditReadViewContainer,
	type EditableDatePicker,
	type Props as EditableDatePickerProps,
} from './index';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyEditableDatePicker = lazy<typeof EditableDatePicker>(() =>
	import(/* webpackChunkName: "async-editable-date-picker" */ './index').then(
		(module) => module.EditableDatePicker,
	),
);

export const AsyncEditableDatePicker = (props: EditableDatePickerProps) => (
	<Placeholder
		name="editable-date-picker"
		fallback={
			<SkeletonContainer>
				<Label htmlFor="version-details-editable-date-picker">{props.label}</Label>
				<InlineEditReadViewContainer>
					<DatePickerReadView displayDate={props.displayDate} />
				</InlineEditReadViewContainer>
			</SkeletonContainer>
		}
	>
		<LazyEditableDatePicker {...props} />
	</Placeholder>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SkeletonContainer = styled.div({
	minWidth: '160px',
	marginBottom: token('space.100', '8px'),
});
